import React from 'react';
import PropTypes from 'prop-types';
import './clickableItem.scss';

const clickableItem = (props) => {
  const { title, id, description, additionalText, value, isActive, callback } = props;
  let className = 'ClickableItem ' + id;

  if (isActive){
    className += ' active';
  }

  let descriptionText = description;

  if (value > 0) {
    descriptionText = `${value}€ al mese`;
  } else {
    descriptionText = additionalText;
  }

  return (
    <div
      className={ className }
      onClick={ () => callback(id) }
      data-value={value}
      data-key={id}
    >
      <span className={'title'}>{title}

      </span>
      {
        <span className={'description'}>{descriptionText}</span>
      }
    </div>
  );
};


clickableItem.defaultProps = {
  description: '',
  isActive: false,
  callback: () => {},
};

clickableItem.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.number,
  description: PropTypes.string,
  value: PropTypes.any.isRequired,
  isActive: PropTypes.bool,
  callback: PropTypes.func
};

export default clickableItem;

